import React, { useEffect, useRef } from 'react';
import { getVideo } from '../../../../utils/videoDB';

const SplashVideoPlayer = ({ videoRef, videoKey, handleVideoPlay, handleVideoEnd }) => {
  //const videoRef = useRef(null);

  useEffect(() => {
    let isMounted = true;
    let objectUrl = null;

    const fetchAndLoadVideo = async () => {
      try {
        // Early exit if empty videoKey
        if (!videoKey || videoKey.trim() === '') {
          console.warn('SplashVideoPlayer: Empty or invalid videoKey');
          return;
        }

        const splashdecodedUrl = decodeURIComponent(videoKey); // Decodes %20 to spaces
        const splashfileName = splashdecodedUrl.split('/').pop(); // Takes last segment after /
        const result = await getVideo(splashfileName); // { blob, metadata }
        
        if (!isMounted) {
          console.log('Component unmounted, skipping video setup');
          return;
        }
        
        const blob = result?.blob;

        if (blob && blob instanceof Blob) {
          objectUrl = URL.createObjectURL(blob);

          // Ensure video element exists
          if (videoRef.current) {
            // Clear existing sources
            while (videoRef.current.firstChild) {
              videoRef.current.removeChild(videoRef.current.firstChild);
            }

            // Create and append source element
            const source = document.createElement('source');
            source.src = objectUrl;
            source.type = blob.type || 'video/mp4'; // Default to mp4 if type not specified

            videoRef.current.appendChild(source);

            console.log('Video source set:', objectUrl);
          }
        } else {
          if (videoRef.current) {
            // Clear existing sources
            while (videoRef.current.firstChild) {
              videoRef.current.removeChild(videoRef.current.firstChild);
            }

            // Create and append source element
            const source = document.createElement('source');
            source.src = videoKey;
            source.type = 'video/mp4'; // Default to mp4 if type not specified

            videoRef.current.appendChild(source);

            console.log('Video source set:', videoKey);
          }
          console.error('Invalid blob:', blob);
        }
      } catch (err) {
        console.error('Error loading video:', err);
      }
    };

    fetchAndLoadVideo();

    // Cleanup object URL on unmount
    return () => {
      isMounted = false;
      
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
        objectUrl = null;
      }
      
      // Clean up video element
      if (videoRef.current) {
        const video = videoRef.current;
        video.pause();
        
        // Remove all source elements
        while (video.firstChild) {
          video.removeChild(video.firstChild);
        }
        
        video.removeAttribute('src');
        video.load();
      }
    };
  }, [videoKey]);

  return (
    <video
      ref={videoRef}
      className="videoEle show"
      muted
      preload="auto"
      // controls
      autoPlay
      onPlay={handleVideoPlay}
      onEnded={handleVideoEnd}
      loop={false}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 2 }}
    ></video>
  );
};

export default SplashVideoPlayer;
